import React, { Component } from "react";
import { Container, Row } from 'reactstrap';

class Panier extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        return (
            <>



                <Container>

                    <Row>
                        <div className="col-8 border">
                            <div className="d-flex pt-2">
                                <span className="text-left font-weight-bold color-gh h3"> panier (7) </span>
                                <span className="text-right ml-auto btn border rounded-pill">dzd</span>
                            </div>
                            <div class="form-check ">
                                <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault"/>
                                    <label class=" h6" for="flexCheckDefault">
                                        Tous compris
                                    </label>
                            </div>





                        </div>
                        <div className="col-4">

                        </div>
                    </Row>
                </Container>
            </>)
    }

}
export default Panier;